import React from 'react'
import PropTypes from 'prop-types'
import { Title } from 'react-head'
import ContentArea from '../../components/ContentArea'
import DefaultLayout from '../../components/DefaultLayout'
import Footer from '../../components/Footer/Footer'
import Spinner from '../../components/Spinner/Spinner'
import SubPageHeader from '../../components/SubPageHeader'
import { runQuery } from '../../dato'
import { setSessionItem } from '../../storeManager'
import ErrorPage from '../ErrorPage'
import convert from 'htmr'
import withSSR from '../../components/withSSR/withSSR'
import { FormattedDate } from 'react-intl'

const transforms = {
  // eslint-disable-next-line react/prop-types
  ol: function LowerLatinList({ children }) {
    return <ol className="lower-latin">{children}</ol>
  },
  // eslint-disable-next-line react/prop-types
  table: function CustomTable({ children }) {
    return (
      <table
        className={`
      type-small relative 
      mx-0 border-collapse 
      transform border-1 border-Border 
      bg-transparent shadow-none xl:left-1/2 xl:-translate-x-1/2
    `}
      >
        {children}
      </table>
    )
  },
  // eslint-disable-next-line react/prop-types
  th: function CustomTableHeading({ children }) {
    return (
      <th className="type-small border-1 border-Border px-8 py-4 normal-case tracking-normal text-Type">
        {children}
      </th>
    )
  },
  // eslint-disable-next-line react/prop-types
  td: function CustomTableCell({ children }) {
    return (
      <td className="border-1 border-Border px-8 py-6 align-top">{children}</td>
    )
  },
}

function PrivacyPolicyDato({ data, isLoading, error }) {
  if (isLoading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner width="50" color="green" />
      </div>
    )
  }
  if (error) return <ErrorPage error={error} />
  if (!data) return null

  setSessionItem('bannerShown', true)

  return (
    <DefaultLayout>
      <Title>Privacy Policy - Lifesum</Title>
      <SubPageHeader
        heading={data.title}
        language={false}
        stickyHeader={false}
      />
      <ContentArea>
        <div className="s-text">
          {convert(data.content, { transform: transforms })}
        </div>
        <small className="type-small text-TypeSub">
          Last update: {<FormattedDate value={data.publishedAt} />}
        </small>
      </ContentArea>
      <Footer />
    </DefaultLayout>
  )
}

PrivacyPolicyDato.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
}

const query = gql`
  query Policy($slug: String!) {
    privacyPolicy(filter: { slug: { eq: $slug } }) {
      title
      content
      publishedAt: _publishedAt
    }
  }
`

PrivacyPolicyDato.getInitialProps = ({ location, isPreview }) => {
  return runQuery(
    query,
    { slug: location.pathname.replace('/', '') },
    isPreview,
  ).then(({ privacyPolicy }) => privacyPolicy)
}

export default withSSR(PrivacyPolicyDato)
